import { gql } from '@apollo/client'

export interface SaveBackupApproversResponse {
  data: {
    saveBackupApprovers: {
      isSuccess: boolean
      error: string
      __typename: string
    }
  }
}

export interface SaveBackupApproversRequestInput {
  input: {
    sendEmails: boolean
    backupApprovers: Array<{
      id: string
      workflowApproverEmail: string
      backupApproverEmail: string
      approverGroupId: number
      region: string
      markets: string
      countryCodes: string
      productLines: string
      backupBeginDate: string
      backupEndDate: string
      isActive: boolean
    }>
  }
}
export const SAVE_BACKUP_APPROVERS = gql`
  mutation saveBackupApprovers($input: SaveBackupApproversRequestInput) {
    saveBackupApprovers(input: $input) {
      isSuccess
      error
      __typename
    }
  }
`
